import { createSlice } from "@reduxjs/toolkit";
import { dateFilterTypes, getDateFilterRanges } from "features/loads/components/LoadsDashboard/loadsDashboardConsts";

const dateRanges = getDateFilterRanges({ yearCount: 3 });
const initialDates = {
    dateFilterType: { value: dateFilterTypes.YEAR },
    dateFilter: { value: 1 },
    startDate: { value: dateRanges?.[dateFilterTypes.YEAR]?.[0]?.startDate.toDateString() },
    endDate: { value: dateRanges?.[dateFilterTypes.YEAR]?.[0]?.endDate.toDateString() }
};

const locationFilters = {
    lotId: { value: [] },
    clientId: { value: '' },
    lotFilter: { value: 'all' } // 'all', 'tenant', 'washRule'
};

const activityFilters = {
    autoGenerated: { value: 'all' },
    activityItemId: { value: null },
    ...initialDates
};

export const washDashboardSlice = createSlice({
    name: 'washDashboardSlice',
    initialState: {
        locationFilters: { ...locationFilters },
        activityFilters: { ...activityFilters }
    },
    reducers: {
        setLocationFilters: (state, action) => {
            state.locationFilters = action.payload;
        },
        setActivityFilters: (state, action) => {
            state.activityFilters = action.payload;
        },
        setFilters: (state, action) => {
            const { locationFilters, activityFilters } = action.payload;
            state.locationFilters = { ...locationFilters };
            state.activityFilters = { ...activityFilters };
        },
    },
    selectors: {
        selectAllFilters: state => ({
            ...state.locationFilters,
            ...state.activityFilters
        }),
        selectLocationFilters: state => state.locationFilters,
        selectActivityFilters: state => state.activityFilters
    }
});

export const { setLocationFilters, setActivityFilters, setFilters } = washDashboardSlice.actions;
